export enum OperationStatus {
    IN_PROGRESS = 'in_progress',
    COMPLETED = 'completed',
}
